module.exports = "https://cdn.redage.net/src/views/donate/sapper/images/logo-sapper.png";